import AgentHeadShot from "@/components/agent-headshot.vue"
export default {
    inject: ['useExternalUrl'],
    computed: {
        redirectUrl({ agent }) {
            if (this.useExternalUrl && agent.externalUrl) {
                return agent.externalUrl
            } else {
                return agent.detailUrl
            }
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        agentTargetImage({ agent }) {
            return agent.headShots?.['photoOneByOne'] || agent.headShots?.['photoThreeByFour'] || agent.headShots?.['photoFiveByThree'] || agent.image
        },
        agentTargetImage3By4({ agent }) {
            return agent.headShots?.['photoThreeByFour'] || agent.headShots?.['photoOneByOne'] || agent.headShots?.['photoFiveByThree'] || agent.image
        }
    },
    components: {
        AgentHeadShot
    }
}